const meetingManagement = () => import('@/pages/meeting/index')
const meetingListManagement = () => import('@/pages/meeting/list/list')
const meetingAddManagement = () => import('@/pages/meeting/server/list')
const meetingPlaceManagement = () => import('@/pages/meeting/place/list')
const meetingAppointmentManagement = () => import('@/pages/meeting/appointment/list')
const ListAdd = () => import('@/pages/meeting/list/add')
const AppointmentDetails = () => import('@/pages/meeting/appointment/details')
const AddServer = () => import('@/pages/meeting/server/details')
const PlaceAdd = () => import('@/pages/meeting/place/add')
export default [
  {
    path: '/metting-management',
    component: meetingManagement,
    name: 'meetingManagement',
    children: [
      {
        path: 'list-management',
        component: meetingListManagement,
        name: 'meetingListManagement',
        meta: [
          {
            name: '会议室列表',
            url: '/metting-management/list-management'
          }
        ]
      },
      {
        path: 'list-management/add',
        component: ListAdd,
        meta: [
          {
            name: '会议室列表',
            url: '/metting-management/list-management'
          },
          {
            name: '新增会议室',
            url: 'add',
            noCache: true
          }
        ]
      },
      {
        path: 'list-management/set/:id',
        component: ListAdd,
        meta: [
          {
            name: '会议室列表',
            url: '/metting-management/list-management'
          },
          {
            name: '会议室编辑',
            url: 'set',
            noCache: true
          }
        ]
      },
      {
        path: 'appointment-management',
        component: meetingAppointmentManagement,
        name: 'meetingAppointmentManagement',
        meta: [
          {
            name: '预约管理',
            url: '/metting-management/appointment-management'
          }
        ]
      },
      {
        path: 'appointment-management/get/:id',
        component: AppointmentDetails,
        meta: [
          {
            name: '预约管理',
            url: '/metting-management/appointment-management'
          },
          {
            name: '查看详情',
            url: 'get',
            noCache: true
          }
        ]
      },
      {
        path: 'server-management',
        component: meetingAddManagement,
        name: 'meetingAddManagement',
        meta: [
          {
            name: '服务管理',
            url: ''
          }
        ]
      },
      {
        path: 'server-management/add',
        component: AddServer,
        meta: [
          {
            name: '服务管理',
            url: '/metting-management/server-management'
          },
          {
            name: '新增增值服务',
            url: 'add',
            noCache: true
          }
        ]
      },
      {
        path: 'server-management/set',
        component: AddServer,
        meta: [
          {
            name: '增值服务',
            url: '/metting-management/server-management'
          },
          {
            name: '编辑增值服务',
            url: 'set',
            noCache: true
          }
        ]
      },
      {
        path: 'server-management/funtion-add',
        component: AddServer,
        meta: [
          {
            name: '会议功能',
            url: '/metting-management/server-management'
          },
          {
            name: '新增会议功能',
            url: 'funtion-add'
          }
        ]
      },
      {
        path: 'server-management/funtion-set',
        component: AddServer,
        meta: [
          {
            name: '会议功能',
            url: '/metting-management/server-management'
          },
          {
            name: '编辑会议功能',
            url: 'funtion-set'
          }
        ]
      },
      // {
      //     path: 'meeting-funtion-management',
      //     component: meetingFuntionManagement,
      //     meta: [
      //         {
      //             name: '会议功能',
      //             url: ''
      //         }
      //     ]
      // },
      // {
      //     path: 'meeting-funtion-management/add',
      //     component: FuntionAdd,
      //     meta: [
      //         {
      //             name: '会议功能',
      //             url: '/metting-management/meeting-funtion-management'
      //         },
      //         {
      //             name: '新增会议功能',
      //             url: 'add'
      //         }
      //     ]
      // },
      {
        path: 'place-management',
        component: meetingPlaceManagement,
        meta: [
          {
            name: '场地布局管理',
            url: ''
          }
        ]
      },
      {
        path: 'place-management/add',
        component: PlaceAdd,
        meta: [
          {
            name: '场地布局管理',
            url: '/metting-management/place-management'
          },
          {
            name: '新增场地布局',
            url: 'add'
          }
        ]
      },
      {
        path: 'place-management/set',
        component: PlaceAdd,
        meta: [
          {
            name: '场地布局管理',
            url: '/metting-management/place-management'
          },
          {
            name: '编辑场地布局',
            url: 'set'
          }
        ]
      }
    ]
  }
]
